import { BestDeals } from 'components/main-page/home-page/best-deals/BestDeals'
import { useEffect, useState } from 'react'
import { useValidation } from 'hooks/useValidation'
import { BEST_DEALS_VALIDATION } from 'services/validation/home-page/bestDealsValidation'
import { constructOptionMultipleSelect, convertErrorMessage, getValueFromArray } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import { API_BEST_DEALS } from 'services/api-home-page/apiBestDeals'
import { Alert } from 'avo-ui'

const INITIAL_STATE = {
    is_show: false,
    best_deal: {
        title: null,
        product_ids: [],
    },
}

const FIELD_NAME_DETAIL = {
    title: 'Title',
    product_ids: 'Product list',
}

export const BestDealsContainer = () => {
    const [bestDealsDetail, setBestDealsDetail] = useState(INITIAL_STATE)
    const [optionsProduct, setOptionsProduct] = useState([])
    const [errorMessage, setErrorMessage] = useState({})
    const { fetching: getBestDealsDetail, isLoading } = useFetch(API_BEST_DEALS.DETAIL)
    const { fetching: getProductList } = useFetch(API_BEST_DEALS.PRODUCT_LIST)
    const { fetching: updateBestDeals, isLoading: isUpdating } = useFetch(API_BEST_DEALS.UPDATE)
    const { validateForm, errorForm } = useValidation({
        form: bestDealsDetail,
        schema: BEST_DEALS_VALIDATION,
    })

    const onChangeForm = (e) => {
        const { name, value, checked } = e
        let newData
        if (checked === undefined) {
            newData = { best_deal: { ...bestDealsDetail?.best_deal, [name]: value } }
        } else {
            newData = { [name]: checked }
        }
        setBestDealsDetail({ ...bestDealsDetail, ...newData })
    }

    const onSearchProduct = (keyword) => {
        getProductList({ search: keyword }).then((response) => {
            const newOption = constructOptionMultipleSelect(response?.data, 'name', 'id')
            setOptionsProduct(newOption)
        })
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(() => {
            const newPayload = {
                ...bestDealsDetail,
                best_deal: {
                    ...bestDealsDetail?.best_deal,
                    product_ids: getValueFromArray(bestDealsDetail?.best_deal?.product_ids, 'value'),
                },
            }
            updateBestDeals(newPayload)
                .then(() => {
                    return Alert({
                        icon: 'success',
                        title: 'Success',
                        message: 'Best Deals Updated !',
                    })
                })
                .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
        })
    }

    useEffect(() => {
        getBestDealsDetail().then((response) => {
            const data = { ...response?.data }
            const { products, ...bestDealRest } = data?.best_deal
            const newDetail = {
                ...data,
                best_deal: {
                    ...bestDealRest,
                    product_ids: constructOptionMultipleSelect(products, 'name', 'id'),
                },
            }
            setBestDealsDetail(newDetail)
        })
    }, [])

    const props = {
        isShow: bestDealsDetail?.is_show,
        bestDealsDetail: bestDealsDetail?.best_deal,
        optionsProduct,
        errorForm: { best_deal: { ...errorForm, ...errorMessage } },
        onChangeForm,
        onSearchProduct,
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <BestDeals {...props} />
}
